<template>
  <TableGradient
      icon-name="cloud-upload-alt"
      :title="$t('functions.listagem.titulo_pagina')"
      :text-empty="$t('functions.listagem.table.empty')"
      route-new="functions.create"
      :text-new="$t('functions.listagem.novo')"
      :fields="fields"
      :fields-filter="filter"
      :items="functions"
      :paginator="pagination"
      :loading="isLoading"
      @list="evt => $store.dispatch('functions/listAllPaginated', evt)"
      table-data>
    <template v-slot:cell(id)="linha">
      <router-link :id="`link-edit-${linha.index}`"
                   :to="{ name: 'functions.edit', params: { id: linha.item.id }}" class="font-weight-bold">
        {{ $t('functions.listagem.table.editar') }}
      </router-link>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import TableData from "@/components/TableData";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableData, TableGradient},
  computed: {
    ...mapGetters({
      store_isLoading: 'functions/isLoading',
      pagination: 'functions/pagination',
      functions: 'functions/all'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('functions.listagem.table.nome'), sortable: true},
        {key: 'function_url', label: this.$t('functions.listagem.table.url'), sortable: true},
        {key: 'auth_url', label: this.$t('functions.listagem.table.url_autenticacao'),sortable: true},
        {key: 'auth_class', label: this.$t('functions.listagem.table.classe_autenticacao'), sortable: true},
        {key: 'credential.name', label: this.$t('functions.listagem.table.credencial'), sortable: true, keyFullName: 'credential.name'},
        {key: 'assembling_class', label: this.$t('functions.listagem.table.classe_cloud_function'), sortable: true},
        {key: 'id', label: this.$t('functions.listagem.table.editar')}
      ],
      filter: [
        {key: 'name', label: this.$t('functions.listagem.table.nome')}
      ],
    }
  },
  methods: {
    ...mapActions([
      'functions/listAllPaginated'
    ])
  },
  mounted() {
    this['functions/listAllPaginated']()
    this.mounted = true
  }
}
</script>
